// extracted by mini-css-extract-plugin
export default {"imgdiv":"_5e1fa16d6c ea66462531","img":"_6e50676b63 _68fcbc1090"};